import { useState } from 'react';

/** The create/edit drawer's open state for a reference-data directory (garages, suppliers): present row to edit it, absent to create one. */
export function useDirectoryDrawer<V>(resetSaveError: () => void) {
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState<V | undefined>(undefined);

  function openDrawer(row?: V): void {
    resetSaveError();
    setEditing(row);
    setOpen(true);
  }

  return { open, editing, openDrawer, close: () => setOpen(false) };
}
